import React from 'react';
import styled from 'styled-components';
import { FaSearch } from 'react-icons/fa';

interface RelatorioCardProps {
  corBotao?: string;
  titulo: React.ReactNode;
  subtitulo: React.ReactNode;
  onAplicarFiltros: () => void;
}

const Card = styled.div`
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  padding: 20px;
  width: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
`;

const Titulo = styled.div`
  font-size: 1.1rem;
  font-weight: 700;
  color: #1A202C;
  margin-bottom: 4px;
`;

const Subtitulo = styled.div`
  font-size: 0.85rem;
  color: #64748B;
  margin-bottom: 20px;
  line-height: 1.4;
`;

const Divisoria = styled.hr`
  border: none;
  border-top: 1px solid #E2E8F0;
  margin: 8px 0 12px 0;
`;

const Botao = styled.button<{ cor?: string }>`
  background-color: ${({ cor }) => cor || '#007bff'};
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  font-weight: 500;
  gap: 8px;
  width: 100%;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.85;
  }
`;

export const RelatorioCard: React.FC<RelatorioCardProps> = ({
  titulo,
  subtitulo,
  corBotao,
  onAplicarFiltros,
}) => (
  <Card>
    <div>
      <Titulo>{titulo}</Titulo>
      <Divisoria />
      <Subtitulo>{subtitulo}</Subtitulo>
    </div>
    <Botao cor={corBotao} onClick={onAplicarFiltros}>
      <FaSearch size={13} /> Gerar Relatório
    </Botao>
  </Card>
);
